import Checkbox from './checkbox';

export { type CheckboxProps } from './checkbox';

export default Checkbox;
